export default {
      id: "menu__help-usage",
      viewBox: "0 0 23 23",
      url: __webpack_public_path__ + "img/icons.svg#menu__help",
      toString: function () {
        return this.url;
      }
    }